import { useContent } from "@/context/ContentContext";
import EventSection from "@/components/site/EventSection";
import UpcomingShows from "@/components/site/UpcomingShows";
import PageLoader from "@/components/site/PageLoader";

export default function EventPage() {
  const c = useContent();
  if (!c) return <PageLoader />;
  return (
    <div className="pt-[72px]">
      <EventSection event={c.event || {}} />
      <UpcomingShows />
    </div>
  );
}
